import React, { useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { message, Upload, Typography, Alert, Input, Button, Tooltip } from 'antd';
const { Paragraph } = Typography;
const { Dragger } = Upload;
import classes from './ReconnectGCPCloudAccount.module.css';
import GCPSvgIcon from '@/../public/gcp-logo.svg';
import { getSignedUrl } from '@/utils/utils';

export const BasicInfoStepsByShell = ({ handleFileChange, handleBeforeUpload, props }) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const { gcpSignedURL, loadingSignedUrl, dispatch } = props;

  const signedUrlCommand = `wget "${gcpSignedURL}" -O basic-onboarding.zip`;

  return (
    <>
      {/* <h5 className={classes.stepsHeading}>
        <span>Create Service Account</span>
      </h5> */}
      <div className={(classes.flexColumn, classes.cardMain)}>
        <div style={{ display: 'flex', gap: '4rem', justifyContent: 'space-between' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '10px',
            }}
          >
            <Alert
              message="Please make sure that you have deleted the service account “cloudnosys-*@” and its respective key “cloudnosys-*.json” before proceeding to following the steps:"
              type="info"
              showIcon
              style={{ marginBottom: '30px' }}
            />
            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>1</div>
                </div>
              </div>
              <div style={{ display: 'inline', marginTop: '-5px', marginBottom: '12px' }}>
                <p>
                  <b>Access GCP Console and Open Cloud Shell:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    <p style={{ display: 'inline', margin: '0' }}>
                      Log in to Google Cloud Console by clicking
                    </p>
                    <a
                      href="https://console.cloud.google.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    >
                      &nbsp;<u>here</u>&nbsp;
                    </a>
                    <p style={{ display: 'inline', margin: '0' }}>
                      and select the project you want to connect to Cloudnosys.
                    </p>
                  </li>

                  <li>
                    Click the “Activate Cloud Shell” button in the top-right corner to open the
                    terminal.
                  </li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>2</div>
                </div>
              </div>
              <div id="myForm">
                <p>
                  <b>Download the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>Copy the SignedURL from the Cloudnosys portal.</li>
                  <li>In the Cloud Shell, run this command to download the onboarding script:</li>
                </ul>
                <div
                  style={{
                    display: 'flex',
                    gap: '1.7rem',
                  }}
                >
                  {gcpSignedURL.length ? (
                    <Paragraph
                      copyable={{ text: signedUrlCommand }}
                      className={classes.paragraphStyle}
                    >
                      {signedUrlCommand}
                    </Paragraph>
                  ) : (
                    <Paragraph className={classes.paragraphStyle}>
                      Click on the Generate Signed Url Button
                    </Paragraph>
                  )}
                  <Tooltip title="The Signed URL will be valid for 15 min Only">
                    <Button
                      style={{ backgroundColor: 'transparent', color: '#252525A6' }}
                      onClick={() => getSignedUrl('basic', 'gcp', dispatch, setIsDisabled)}
                      size="large"
                      disabled={isDisabled}
                      loading={loadingSignedUrl}
                    >
                      <img
                        src={GCPSvgIcon}
                        alt="Aws logo here"
                        style={{ marginRight: '10px', height: '1rem', width: '2rem' }}
                      />
                      Generate Signed URL
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>3</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Unzip and Run the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Run the following combined command to unzip the file, make the script
                    executable, and then execute the script:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  unzip basic-onboarding.zip && chmod +x basic-onboarding.sh &&
                  ./basic-onboarding.sh
                </Paragraph>
                <p>
                  <b>NOTE:</b>&nbsp;This will create a service account with least privileged access
                  and the service account key required to complete onboarding for Basic protection
                  level.
                </p>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>4</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Download the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    In the Cloud Shell, type the following to verify the key file was created:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  ls ~/cloudnosys-sa-*.json
                </Paragraph>
                <ul className={classes.listStyle}>
                  <li>
                    Click the three-dotted “More” menu in the top-right corner of Cloud Shell and
                    select “<b>Download File</b>”.
                  </li>
                  <li>Locate and download the cloudnosys-sa-*.json file to your local machine.</li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>5</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Upload the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Drag and drop, or browse to upload the downloaded JSON key file into the box
                    below.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Dragger
          name="file"
          multiple={false}
          beforeUpload={handleBeforeUpload}
          onChange={handleFileChange}
          // showUploadList={false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Now browse the key or drag and drop in the box below</p>
        </Dragger>
      </div>
      <h5 className={classes.stepsHeading}>
        <span>Enable APIs</span>
      </h5>
      <div className={(classes.flexColumn, classes.cardMain)}>
        <div
          style={{
            display: 'flex',
            gap: '4rem',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '10px',
            }}
          >
            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>1</div>
                </div>
              </div>
              <div>
                <p>
                  Make sure that you have selected the correct GCP project that you would like to
                  connect with Cloudnosys
                </p>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>2</div>
                </div>
              </div>
              <div>
                <p>
                  Open the Google Command Line Interface (CloudShell) and enable the required APIs
                  using the following command:
                </p>

                <Paragraph copyable className={classes.paragraphStyle}>
                  gcloud services enable cloudapis.googleapis.com cloudasset.googleapis.com
                  compute.googleapis.com storage.googleapis.com iam.googleapis.com
                  iamcredentials.googleapis.com containerfilesystem.googleapis.com
                  containerregistry.googleapis.com container.googleapis.com logging.googleapis.com
                  monitoring.googleapis.com cloudresourcemanager.googleapis.com
                  cloudkms.googleapis.com dns.googleapis.com
                </Paragraph>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const AdvanceInfoStepsByShell = ({
  handleFileChange,
  handleBeforeUpload,
  handleInputChange,
  roleNames,
  props,
}) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const { gcpSignedURL, loadingSignedUrl, dispatch } = props;

  const signedUrlCommand = `wget "${gcpSignedURL}" -O advanced-onboarding.zip`;

  return (
    <>
      {/* <h5 style={customStyles.stepsHeadings}>
        <span>Create Service Account</span>
      </h5> */}
      <div className={(classes.flexColumn, classes.cardMain)}>
        <div style={{ display: 'flex', gap: '4rem', justifyContent: 'space-between' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '10px',
            }}
          >
            <Alert
              message="Please make sure that you have deleted the service account “cloudnosys-*@”, its respective key “cloudnosys-*.json”, custom roles “cloudnosys-*”, and the tag key/value before proceeding to follow the steps:"
              type="info"
              showIcon
              style={{ marginBottom: '30px' }}
            />

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>1</div>
                </div>
              </div>
              <div style={{ display: 'inline', marginTop: '-5px', marginBottom: '12px' }}>
                <p>
                  <b>Access GCP Console and Open Cloud Shell:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    <p style={{ display: 'inline', margin: '0' }}>
                      Log in to Google Cloud Console by clicking
                    </p>
                    <a
                      href="https://console.cloud.google.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    >
                      &nbsp;<u>here</u>&nbsp;
                    </a>
                    <p style={{ display: 'inline', margin: '0' }}>
                      and select the project you want to connect to Cloudnosys.
                    </p>
                  </li>

                  <li>
                    Click the “Activate Cloud Shell” button in the top-right corner to open the
                    terminal.
                  </li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>2</div>
                </div>
              </div>
              <div id="myForm">
                <p>
                  <b>Download the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>Copy the SignedURL from the Cloudnosys portal.</li>
                  <li>In the Cloud Shell, run this command to download the onboarding script:</li>
                </ul>
                <div
                  style={{
                    display: 'flex',
                    gap: '1.7rem',
                  }}
                >
                  {gcpSignedURL.length ? (
                    <Paragraph
                      copyable={{ text: signedUrlCommand }}
                      className={classes.paragraphStyle}
                    >
                      {signedUrlCommand}
                    </Paragraph>
                  ) : (
                    <Paragraph className={classes.paragraphStyle}>
                      Click on the Generate Signed Url Button
                    </Paragraph>
                  )}
                  <Tooltip title="The Signed URL will be valid for 15 min Only">
                    <Button
                      style={{ backgroundColor: 'transparent', color: '#252525A6' }}
                      onClick={() => getSignedUrl('advanced', 'gcp', dispatch, setIsDisabled)}
                      size="large"
                      disabled={isDisabled}
                      loading={loadingSignedUrl}
                    >
                      <img
                        src={GCPSvgIcon}
                        alt="Aws logo here"
                        style={{ marginRight: '10px', height: '1rem', width: '2rem' }}
                      />
                      Generate Signed URL
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>3</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Unzip and Run the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Run the following combined command to unzip the file, make the script
                    executable, and then execute the script:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  unzip advanced-onboarding.zip && chmod +x advanced-onboarding.sh &&
                  ./advanced-onboarding.sh
                </Paragraph>
                <p>
                  <b>NOTE:</b>&nbsp;This will create a service account with least privileged access,
                  custom IAM roles for best practices, tags for resource management and tracking,
                  and the service account key required to complete onboarding for Advance protection
                  level
                </p>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>4</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Download the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    In the Cloud Shell, type the following to verify the key file was created:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  ls ~/cloudnosys-sa-*.json
                </Paragraph>
                <ul className={classes.listStyle}>
                  <li>
                    Click the three-dotted “More” menu in the top-right corner of Cloud Shell and
                    select “<b>Download File</b>”.
                  </li>
                  <li>Locate and download the cloudnosys-sa-*.json file to your local machine.</li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>5</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Custom Roles:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>Provide the custom roles names in the fields below:</li>
                </ul>
                <div
                  style={{
                    display: 'flex',
                    gap: '1.7rem',
                    marginBottom: '1rem',
                  }}
                >
                  <Input
                    placeholder="Cloudnosys Create Role ****"
                    value={roleNames.cloudnosysCreateRole}
                    onChange={e => handleInputChange('cloudnosysCreateRole', e)}
                  />
                  <Input
                    placeholder="Cloudnosys Delete Role ****"
                    value={roleNames.cloudnosysDeleteRole}
                    onChange={e => handleInputChange('cloudnosysDeleteRole', e)}
                  />
                </div>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>5</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Upload the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Drag and drop, or browse to upload the downloaded JSON key file into the box
                    below.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Dragger
          name="file"
          multiple={false}
          beforeUpload={handleBeforeUpload}
          onChange={handleFileChange}
          // showUploadList={false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Now browse the key or drag and drop in the box below</p>
        </Dragger>
      </div>
      <h5 className={classes.stepsHeading}>
        <span>Enable APIs</span>
      </h5>
      <div className={(classes.flexColumn, classes.cardMain)}>
        <div
          style={{
            display: 'flex',
            gap: '4rem',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '10px',
            }}
          >
            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>1</div>
                </div>
              </div>
              <div>
                <p>
                  Make sure that you have selected the correct GCP project that you would like to
                  connect with Cloudnosys
                </p>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>2</div>
                </div>
              </div>
              <div>
                <p>
                  Open the Cloud Shell in the GCP Console (top right corner icon) and enable the
                  required APIs using the following command
                </p>

                <Paragraph copyable className={classes.paragraphStyle}>
                  gcloud services enable cloudapis.googleapis.com cloudasset.googleapis.com
                  compute.googleapis.com storage.googleapis.com iam.googleapis.com
                  iamcredentials.googleapis.com containerfilesystem.googleapis.com
                  containerregistry.googleapis.com container.googleapis.com logging.googleapis.com
                  monitoring.googleapis.com cloudresourcemanager.googleapis.com
                  cloudkms.googleapis.com dns.googleapis.com
                </Paragraph>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
